import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12.3643 10.95L15.9 7.41429L14.4857 6L10.95 9.53571L7.41429 6L6 7.41429L9.53571 10.95L6 14.4857L7.41429 15.9L10.95 12.3643L14.4857 15.9L15.9 14.4857L12.3643 10.95Z"
});

var SvgClose = function SvgClose(props) {
  return _ref;
};

export default SvgClose;